import Cookies from 'js-cookie';

const AUTH_COOKIE_NAMES = [
  'mer_access_token',
  'mer_refresh_token',
  'mer_username',
  'mer_admin_id',
  'mer_id',
  'mer_type',
  'mer_avatar_url',
  'mer_role'
];

const cookieOptions = () => ({
  path: '/',
  sameSite: 'strict',
  secure: window.location.protocol === 'https:'
});

export const saveSessionValue = (name, value) => {
  if (AUTH_COOKIE_NAMES.indexOf(name) === -1 || value === undefined || value === null) {
    return;
  }
  Cookies.set(name, String(value), cookieOptions());
};

export const clearSession = () => {
  AUTH_COOKIE_NAMES.forEach(name => Cookies.remove(name, { path: '/' }));
};

export const getAccessToken = () => Cookies.get('mer_access_token');
export const getRefreshToken = () => Cookies.get('mer_refresh_token');

